let isLoad = false;
localStorage.setItem('zl_token', '');
function isAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return true;
    } else if (isiOS) {
        return false;
    }
}

function connectWebViewJavascriptBridge(callback) {
    // android
    if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
            callback(WebViewJavascriptBridge);
        }, false);
    }
    // ios
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 10);
}

function getToken() {
    console.log('getToken');
    connectWebViewJavascriptBridge(async function (bridge) {
        console.log('getuser_connectWebViewJavascriptBridge')
        // 这个是触发
        bridge.callHandler('h5GetApptoken', {}, function (str) {})

        bridge.registerHandler('h5SendAppToken', res => {
            const {token} = JSON.parse(res)
            console.log('first:' + token)
            localStorage.setItem('zl_token', token);
        })
    })
}

function loginInit(){
    connectWebViewJavascriptBridge(function (bridge) {
        if (isAndroid()&& !isLoad) {
            //android 初始化
            bridge.init(function (message, responseCallback) {})
            isLoad = true;
        }
    })
    getToken();
}

function pageShare(enableShare,shareUrl,shareImg,shareTitle,shareDesc) {
	if(shareImg!=null&&shareImg!=""){
        connectWebViewJavascriptBridge(function (bridge) {
            // 这个是触发
            console.log(shareTitle+"=="+shareDesc+"=="+shareImg+"=="+shareUrl);
            bridge.callHandler('setShareMsg', {"enableShare": enableShare, "shareTitle": shareTitle, "shareContent": shareDesc, "shareImg": shareImg, "shareUrl": shareUrl}, function (str) {
                console.log(str)
             });
        })	
	}    
}

export default {loginInit,pageShare}